import * as Const from '../constants/index';
import State from '../interfaces/state/AccountState';

const initState: State = {
  isLoading: false,
  isError: false,
};

export default function account(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.ACC_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.ACC_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.ACC_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.ACC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };

    default:
      return state;
  }
}
